"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function normalize(str) {
    return str.replace(/\\/gm, '/').replace(/\r/gm, '\n').replace(/\n\n/gm, '\n').trim();
}
exports.normalize = normalize;
function parseMultiObjects(value) {
    var values = value.split(/\}\s*\{/);
    if (values.length === 0) {
        return values;
    }
    return values.map(function (d, i) { return "" + (i > 0 ? '{' : '') + d + (i < values.length - 1 ? '}' : ''); });
}
exports.parseMultiObjects = parseMultiObjects;
function randomBaseDir() {
    return "/src" + Math.random().toString(36).slice(3);
}
exports.randomBaseDir = randomBaseDir;
function buildOptions(options, coptions) {
    var copy = Object.assign({}, options);
    delete copy.signal;
    delete copy.onPartialResult;
    delete copy.onChunk;
    if (!coptions.extraIncludeFiles) {
        return copy;
    }
    if (copy.extraIncludeFiles) {
        copy.extraIncludeFiles = Object.assign({}, coptions.extraIncludeFiles, copy.extraIncludeFiles);
    }
    else {
        copy.extraIncludeFiles = coptions.extraIncludeFiles;
    }
    return copy;
}
exports.buildOptions = buildOptions;
//# sourceMappingURL=utils.js.map